import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();
// 카테고리 목록
export const categoryListState = atom({
  key: "categoryListState",
  default: [],
  effects_UNSTABLE: [persistAtom],
});

// 게시글 목록
export const boardListState = atom({
  key: "boardListState",
  default: [],
  effects_UNSTABLE: [persistAtom],
});

// 페이지 네이션 관리
export const pageNationState = atom({
  key: "pageNationState",
  default: 1,
  effects_UNSTABLE: [persistAtom],
});

export const PageNationMaxPageState = atom({
  key: "pageNationPageState",
  default: {
    page: 1,
    totalCount: 0,
  },
  effects_UNSTABLE: [persistAtom],
});

// 접속했던 데이터 목록
export const ListJoinState = atom({
  key: "listJoinState",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
